import React from 'react';
import { cn } from '../../../lib/cn';

/**
 * SectionTitle, `.dsk-section-title`.
 *
 * Source selector: `system.css` `.dsk-section-title`.
 *
 * Sized at `--dsk-section` (20px), one step under the page title, which is what
 * keeps a page's scan line readable: one 28px title, then 20px section heads,
 * then body. Defaults to `<h2>` so the document outline is real; drop to `h3`
 * with `as` when the section is nested under another one.
 */
export const SectionTitle = React.forwardRef(function SectionTitle(
  { as: Component = 'h2', className, ...rest },
  ref,
) {
  return <Component ref={ref} className={cn('dsk-section-title', className)} {...rest} />;
});
SectionTitle.displayName = 'SectionTitle';

export default SectionTitle;
